

































































import { Component, Prop, PropSync, Watch, Model, Ref } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import PinchZoom from 'vue-pinch-zoom'
import loadImage from 'blueimp-load-image'

@Component({
  components: { PinchZoom, loadImage },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @Model('input', { default: null }) readonly value: any
  @PropSync('url', { type: String }) urlString: string
  @Prop({ default: '1' }) readonly ratio: string | number
  @Prop({ default: undefined }) readonly width: string | undefined
  @Prop({ default: undefined }) readonly height: string | undefined
  @Prop({ default: false }) readonly outlined: boolean
  @Prop({ default: false }) readonly round: boolean
  @Prop({ default: false }) readonly readonly: boolean
  @Prop({ default: false }) readonly disabled: boolean
  @Ref() fileInput
  @Ref() imageWrap: HTMLDivElement

  MAX_SIZE = 3145728 // 1024 x 1024 x 3 = 3M

  uploadFile: any = null
  showImagePop: boolean = false
  imgLoaded: boolean = false
  preViewImage: string | undefined = null
  calculatedRatio: string | number = null
  size = {
    width: null,
    height: null,
  }

  sizeStyle: string = ''

  get imagesRatio() {
    return (100 / Number(this.calculatedRatio)).toFixed(4)
  }

  created() {
    console.log('created - ', this.value?.name)
    this.preViewImage = this.urlString
  }

  mounted() {
    this.sizeInit()
  }

  sizeInit() {
    this.calculatedRatio = this.ratio
    this.size = {
      width: this.width ? this.calcSize(this.width) : undefined,
      height: this.height ? this.calcSize(this.height) : undefined,
    }
    if (this.size.width && this.size.height) {
      this.calculatedRatio = this.calcRatio()
    }
    // console.log('calc - ', this.calculatedRatio, this.imagesRatio)
  }

  calcRatio() {
    const width = this.imageWrap.clientWidth
    const height = this.imageWrap.clientHeight

    return (height / width).toFixed(4)
  }

  calcSize(size) {
    if (typeof size === 'string') {
      if (size.charAt(size.length - 1) !== '%') {
        size = size + 'px'
      }
    }
    return size
  }

  onClickChooseImg() {
    if (this.disabled === true) return
    // console.log('choose img click!!')
    this.fileInput.$refs.input.click()
  }

  onClickModify() {
    if (this.disabled === true) return
    this.fileInput.$refs.input.click()
  }

  onClickZoom() {
    if (this.imgLoaded && this.preViewImage) {
      this.showImagePop = true
    } else {
      alert('이미지가 로드 되지 않았습니다.')
    }
  }

  async onClickRemove() {
    if (this.disabled === true) return
    if (await confirm('삭제하시겠습니까?')) {
      // if (this.uploadFile === null) this.onUploadFileChanged(null)
      this.uploadFile = null
      this.preViewImage = null
      this.urlString = null

      // this.$emit('change')
    }
  }

  imageResize(imageFile: File) {
    const self = this

    loadImage(
      imageFile,
      (imgInfo, data) => {
        const width = imgInfo.width as number
        const height = imgInfo.height as number
        const orientation = data.exif?.get('Orientation')

        console.log('meta', imgInfo.width, imgInfo.height)
        console.log('orientation', orientation)

        const reader = new FileReader()
        reader.readAsDataURL(imageFile)
        reader.onload = function () {
          const tempImg = new Image()
          tempImg.src = reader.result

          tempImg.onload = function () {
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height

            // if (orientation === 6) {
            //   // 시계방향 90도
            //   canvas.getContext('2d').translate(width, 0)
            //   canvas.getContext('2d').rotate((90 * Math.PI) / 180)
            //   canvas.getContext('2d').drawImage(tempImg, 0, 0, height, width)
            // } else if (orientation === 8) {
            //   // 반시계방향 90도
            //   canvas.getContext('2d').translate(0, height)
            //   canvas.getContext('2d').rotate((-90 * Math.PI) / 180)
            //   canvas.getContext('2d').drawImage(tempImg, 0, 0, height, width)
            // } else if (orientation === 3) {
            //   // 180도
            //   canvas.getContext('2d').translate(width, height)
            //   canvas.getContext('2d').rotate((180 * Math.PI) / 180)
            //   canvas.getContext('2d').drawImage(tempImg, 0, 0, width, height)
            // } else {
            //   canvas.getContext('2d').drawImage(tempImg, 0, 0, width, height)
            // }

            canvas.getContext('2d').drawImage(tempImg, 0, 0, width, height)

            canvas.toBlob(
              (blob) => {
                self.uploadFile = new File([blob], imageFile.name)
                self.preViewImage = URL.createObjectURL(self.uploadFile)
                console.log(self.uploadFile)
              },
              'image/jpeg',
              0.95
            )
          }
        }
      },
      {
        maxWidth: 1600,
        maxHeight: 1600,
        meta: true,
        canvas: true,
        orientation: true,
      }
    )
  }

  onChangeFileInput() {
    console.log('onChangeFileInput()', this.uploadFile)

    if (this.uploadFile) {
      if (!this.uploadFile.type) {
        alert('알 수 없는 파일입니다.')
        this.uploadFile = null
        return
      } else if (this.uploadFile.type !== 'image/jpeg' && this.uploadFile.type !== 'image/png') {
        alert('지원하지 않는 파일 형식입니다.')
        this.uploadFile = null
        return
      }
    }

    this.imageResize(this.uploadFile)

    // 파일 불러오기(파일 탐색기 화면) 화면에서 취소를 선택하면 null 값 리턴함
    // if (this.uploadFile) this.preViewImage = URL.createObjectURL(this.uploadFile)
    // else this.preViewImage = null
  }

  @Watch('urlString', { deep: true })
  onChangeUrl(val) {
    console.log('onChangeUrl() urlString Watch - ', val, 'preViewImage', this.preViewImage)
    if (val) {
      this.preViewImage = val
      this.uploadFile = null
    }

    // this.urlString = val
  }

  @Watch('value', { deep: true })
  onValueChanged(val) {
    console.log('onValueChanged() Watch - ', val)
    this.uploadFile = val
    if (!val && !this.urlString) this.preViewImage = null
  }

  @Watch('uploadFile')
  onUploadFileChanged(val) {
    console.log('onUploadFileChanged', val?.name)
    if (val) this.urlString = null
    this.$emit('input', val)
    this.$emit('change')
  }
}
